import React from 'react';
import PropTypes from 'prop-types';

const LinkyButton = ({ className, ...restProps }) => (
  <button type='button' className={`btn-link ${className}`} {...restProps} />
);

LinkyButton.propTypes = {
  className: PropTypes.string,
};

LinkyButton.defaultProps = {
  className: '',
};

export default LinkyButton;
